import React from "react";
import ContentLoader from "react-content-loader";
import {
  FiArrowLeft,
  FiDollarSign,
  FiShoppingCart,
  FiTarget,
  FiPackage,
  FiFileText,
  FiPercent,
  FiUser,
  FiMapPin,
  FiPhone,
  FiMail,
  FiActivity,
  FiTrendingUp,
  FiLayers,
} from "react-icons/fi";
import { GoOrganization, GoLaw } from "react-icons/go";

const ClientDetailLoadingSkeleton = ({ isDark = true, onVoltar }) => {
  const backgroundColor = isDark ? "#1a1a1a" : "#f0f0f0";
  const foregroundColor = isDark ? "#2a2a2a" : "#e5e7eb";

  return (
    <div className="content-wrapper">
      {/* Botão voltar acima do header */}
      <button className="back-button" onClick={onVoltar}>
        <FiArrowLeft />
        <span>Voltar</span>
      </button>

      {/* Header */}
      <div className="client-header-new">
        <div className="client-info-bar">
          <div className="client-icon">
            <GoOrganization />
          </div>
          <div className="client-content">
            <h2>
              <ContentLoader
                speed={2}
                width={300}
                height={24}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="4" ry="4" width="300" height="24" />
              </ContentLoader>
            </h2>
            <p className="razao-social">
              <ContentLoader
                speed={2}
                width={250}
                height={16}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="3" ry="3" width="250" height="16" />
              </ContentLoader>
            </p>
            <div className="client-badges">
              {[...Array(4)].map((_, i) => (
                <span key={`badge-${i}`} className="badge">
                  <ContentLoader
                    speed={2}
                    width={120}
                    height={14}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="120" height="14" />
                  </ContentLoader>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Tabs de Navegação */}
      <div className="tabs-container">
        <button className="tab active">
          <FiLayers />
          <span>Geral</span>
        </button>
        <button className="tab">
          <GoLaw />
          <span>Reforma Tributária</span>
        </button>
      </div>

      {/* Linha 1: Métricas de Vendas */}
      <div className="kpi-grid kpi-grid-4">
        {[
          { icon: FiDollarSign, label: "Faturamento Total", className: "primary" },
          { icon: FiShoppingCart, label: "Total de Pedidos", className: "success" },
          { icon: FiTarget, label: "Ticket Médio", className: "warning" },
          { icon: FiPackage, label: "Produtos Únicos", className: "info" },
        ].map((item, i) => (
          <div key={`kpi-${i}`} className={`kpi-card ${item.className}`}>
            <div className="card-content">
              <div className="thumb">
                <item.icon />
              </div>
              <div className="text">
                <p>
                  <ContentLoader
                    speed={2}
                    width={100}
                    height={20}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="4" ry="4" width="100" height="20" />
                  </ContentLoader>
                </p>
                <p>{item.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Linha 2: Impostos Atuais */}
      <div className="kpi-grid kpi-grid-4">
        {["ICMS", "PIS", "COFINS", "IPI"].map((label, i) => (
          <div key={`tax-${i}`} className={`kpi-card tax-${label.toLowerCase()}`}>
            <div className="card-content">
              <div className="thumb">
                <FiFileText />
              </div>
              <div className="text">
                <p>
                  <ContentLoader
                    speed={2}
                    width={80}
                    height={18}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="4" ry="4" width="80" height="18" />
                  </ContentLoader>
                </p>
                <p>
                  <ContentLoader
                    speed={2}
                    width={60}
                    height={14}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="60" height="14" />
                  </ContentLoader>
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Linha 3: Carga Tributária */}
      <div className="kpi-grid kpi-grid-3">
        {[
          { icon: FiPercent, label: "Carga por Pedido" },
          { icon: FiDollarSign, label: "Débitos Tributários Atuais", className: "tax-total" },
          { icon: FiPercent, label: "Alíquota Efetiva Atual", className: "primary" },
        ].map((item, i) => (
          <div key={`carga-${i}`} className={`kpi-card ${item.className || ""}`}>
            <div className="card-content">
              <div className="thumb">
                <item.icon />
              </div>
              <div className="text">
                <p>
                  <ContentLoader
                    speed={2}
                    width={80}
                    height={18}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="4" ry="4" width="80" height="18" />
                  </ContentLoader>
                </p>
                <p>{item.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Seção de Contato e Métricas */}
      <div className="section-row">
        {/* Informações de Contato */}
        <div className="stats-card contact-card">
          <div className="card-header">
            <div className="header-title">
              <FiUser />
              <h4>Informações de Contato</h4>
            </div>
          </div>
          <div className="contact-content">
            {[
              { icon: FiMapPin, label: "Endereço" },
              { icon: FiPhone, label: "Telefone" },
              { icon: FiMail, label: "E-mail" },
            ].map((item, i) => (
              <div key={`contact-${i}`} className="contact-item">
                <item.icon />
                <div className="contact-info">
                  <span className="contact-label">{item.label}</span>
                  <span className="contact-value">
                    <ContentLoader
                      speed={2}
                      width={200}
                      height={14}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="200" height="14" />
                    </ContentLoader>
                  </span>
                  {i === 0 && (
                    <span className="contact-detail">
                      <ContentLoader
                        speed={2}
                        width={100}
                        height={12}
                        backgroundColor={backgroundColor}
                        foregroundColor={foregroundColor}
                      >
                        <rect x="0" y="0" rx="3" ry="3" width="100" height="12" />
                      </ContentLoader>
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Métricas de Performance */}
        <div className="stats-card metrics-card">
          <div className="card-header">
            <div className="header-title">
              <FiActivity />
              <h4>Métricas de Performance</h4>
            </div>
          </div>
          <div className="metrics-content">
            {["Primeira Compra", "Última Compra", "Tempo de Relacionamento", "Frequência de Compra"].map((label, i) => (
              <div key={`metric-${i}`} className="metric-row">
                <span className="metric-label">{label}</span>
                <span className={`metric-value ${i === 2 ? "highlight" : ""}`}>
                  <ContentLoader
                    speed={2}
                    width={120}
                    height={14}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="120" height="14" />
                  </ContentLoader>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Gráficos */}
      <div className="section-row">
        {/* Evolução de Vendas */}
        <div className="stats-card chart-card">
          <div className="card-header">
            <div className="header-title">
              <FiTrendingUp />
              <h4>Evolução de Vendas</h4>
            </div>
            <div className="chart-legend">
              <div className="legend-item">
                <div className="legend-color" style={{ backgroundColor: "#3b82f6" }}></div>
                <span>Vendas</span>
              </div>
              <div className="legend-item">
                <div className="legend-color" style={{ backgroundColor: "#10b981" }}></div>
                <span>Impostos</span>
              </div>
            </div>
          </div>
          <div className="chart-body">
            <ContentLoader
              speed={2}
              width={600}
              height={250}
              backgroundColor={backgroundColor}
              foregroundColor={foregroundColor}
            >
              {[...Array(12)].map((_, i) => {
                const x = 20 + i * 48;
                const heights = [180, 220, 160, 240, 200, 190, 210, 170, 230, 195, 215, 185];
                return (
                  <rect key={i} x={x} y={250 - heights[i]} rx="4" ry="4" width="35" height={heights[i]} />
                );
              })}
            </ContentLoader>
          </div>
        </div>

        {/* Distribuição de Impostos */}
        <div className="stats-card chart-card">
          <div className="card-header">
            <div className="header-title">
              <FiFileText />
              <h4>Distribuição de Impostos</h4>
            </div>
          </div>
          <div className="chart-body">
            <div style={{ 
              display: "flex", 
              flexDirection: "column", 
              alignItems: "center", 
              justifyContent: "center", 
              padding: "24px", 
              minHeight: "250px" 
            }}>
              <div style={{
                width: "40px",
                height: "40px",
                border: "4px solid rgba(139, 92, 246, 0.2)",
                borderTop: "4px solid #8b5cf6",
                borderRadius: "50%",
                animation: "spin 1s linear infinite"
              }}></div>
              <style>{`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}</style>
            </div>
          </div>
        </div>
      </div>

      {/* Produtos Comprados e Histórico */}
      <div className="section-row">
        {/* Produtos Comprados */}
        <div className="stats-card list-card">
          <div className="card-header">
            <div className="header-title">
              <FiPackage />
              <h4>Produtos Mais Comprados</h4>
            </div>
          </div>
          <div className="list-body">
            {[...Array(5)].map((_, i) => (
              <div key={`product-${i}`} className="list-item">
                <div className="item-info">
                  <span className="item-name">
                    <ContentLoader
                      speed={2}
                      width={180}
                      height={14}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="180" height="14" />
                    </ContentLoader>
                  </span>
                  <span className="item-meta">
                    <ContentLoader
                      speed={2}
                      width={100}
                      height={11}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="100" height="11" />
                    </ContentLoader>
                  </span>
                </div>
                <div className="item-value">
                  <ContentLoader
                    speed={2}
                    width={80}
                    height={14}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="80" height="14" />
                  </ContentLoader>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Histórico de Compras */}
        <div className="stats-card list-card">
          <div className="card-header">
            <div className="header-title">
              <FiFileText />
              <h4>Histórico Recente</h4>
            </div>
          </div>
          <div className="list-body">
            {[...Array(5)].map((_, i) => (
              <div key={`history-${i}`} className="list-item">
                <div className="item-info">
                  <span className="item-name">
                    <ContentLoader
                      speed={2}
                      width={150}
                      height={14}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="150" height="14" />
                    </ContentLoader>
                  </span>
                  <span className="item-meta">
                    <ContentLoader
                      speed={2}
                      width={80}
                      height={11}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="80" height="11" />
                    </ContentLoader>
                  </span>
                </div>
                <div className="item-value">
                  <ContentLoader
                    speed={2}
                    width={80}
                    height={14}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="80" height="14" />
                  </ContentLoader>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientDetailLoadingSkeleton;
